import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../../global.service';
import { Router } from '@angular/router';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
import { AngularFireAnalytics } from '@angular/fire/analytics';
@Component({
  selector: 'app-channel-list',
  templateUrl: './channel-list.component.html',
  styleUrls: ['./channel-list.component.sass']
})
export class ChannelListComponent implements OnInit {
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public selectBan;
  public content:object;
  //-----------------------------
  public tabActive = 'Mis Equipos y Servicios';
  public session: number=1;
  public chanelList:object;
  public category:object;
  public token: string = sessionStorage.getItem("token");

  public actualViewStep;
  constructor(public AngularFireAnalytics: AngularFireAnalytics, public global: GlobalService, private router: Router,private loadingScreenService: LoadingScreenService) {}
  ngOnInit() {
    this.loadingScreenService.stopLoading();
    this.category=[
        {
            id:1,
            value:"Peliculas"
        },
        {
            id:2,
            value:"Deportes"
        },
        {
            id:3,
            value:"Series"
       },
        {
            id:4,
            value:"Musicales"
        },
        {
            id:5,
            value:"Infantiles"
        },
        {
            id:6,
            value:"Opinión"
        },
        {
            id:7,
            value:"Variedades"
        },
        {
            id:8,
            value:"Internacionales"
        },
        {
            id:9,
            value:"Cultura"
        },
        {
          id:10,
          value:"Nacionales"
        },
        {
          id:11,
          value:"Religiosos"
         }
    ];
  }
  initializeData() {
    this.global.refreshDataTo(this.token);
  }
  changeTab(idtag:number) {
    this.global.validateSession();
    this.session = idtag;
  }
}
